import React, { FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { ResultsType } from '../../../../state/reducers/results.types';
import styles from './legal_basis_item.module.scss';
import { HyperlinkRestrictedBaseModal } from '../../../../../components/HyperlinkRestrictedBaseModal';
import { hasQueryParams } from '../../../../../utils/url-utils/urlUtils';
import { ArticleStats } from '../../../../../components/article-stats/ArticleStats';

type Legislation = NonNullable<ResultsType['snippets']['legalBasis']>[0];

type Props = {
  legislation: Legislation;
  searchQueryUrl?: string;
  source: string;
};

export const LegalBasisSnippetItem: FC<Props> = ({
  legislation,
  source,
  searchQueryUrl = '',
}) => {
  const { mainTitle, articles } = legislation;

  const buildUrl = (url: string, searchQuery: string) => {
    if (!searchQuery) return url;
    if (hasQueryParams(url)) return `${url}&${searchQuery}`;
    return `${url}?${searchQueryUrl}`;
  };

  return (
    <div>
      {articles.map((article) => {
        const url = buildUrl(article.url, searchQueryUrl);
        return (
          <Fragment key={article.docId}>
            <HyperlinkRestrictedBaseModal
              source={source}
              url={url}
              className={styles.label}
            >
              {article.title} · {mainTitle}
            </HyperlinkRestrictedBaseModal>

            <div className={styles.articleContainer}>
              <p
                className={styles.article}
                dangerouslySetInnerHTML={{
                  __html: article.content || article.contentHtml || '',
                }}
              />
              <HyperlinkRestrictedBaseModal
                source={source}
                url={url}
                className={styles.link}
              >
                <FormattedMessage id="search/components/search-snippets/aside/legal-basis/LegalBasisSnippetItem.tsx/1" />
              </HyperlinkRestrictedBaseModal>
              <ArticleStats
                articleId={article.docId}
                url={article.url}
                sourcePage={source}
                queryParam={searchQueryUrl}
              />
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};
